<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-2">
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="sundry-item-predicted-use-report"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="sundry_item_code">SUNDRY ITEM CODE</vs-th>
                <vs-th width="15%" sort-key="sundry_product_code">SUNDRY PRODUCT CODE</vs-th>
                <vs-th width="20%">SUNDRY PRODUCT NAME</vs-th>
                <vs-th width="20%">SUPPLIER</vs-th>
                <vs-th width="15%">CURRENT STOCK LEVEL</vs-th>
                <vs-th width="15%">SUNDRY ITEM ON ORDER</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].sundry_item_code">
                    <HyperLink :id="data[indextr].id" type="sundry" :open="true">
                    {{ data[indextr].sundry_item_code}}
                    </HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{ data[indextr].sundry_product_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    <HyperLink :id="data[indextr].supplier_id" type="supplier">
                    {{ data[indextr].supplier}}
                    </HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].current_stock_level">
                    {{ data[indextr].current_stock_level}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_item_on_order">
                    {{ data[indextr].sundry_item_on_order}}
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const sundrySupplierRepository = RepositoryFactory.get('sundry')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'sundry-item-predicted-use-report',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
    },
    methods: {
      async refreshData () {
        this.fetchSundryItemsUseReportDetails()
      },
      async fetchSundryItemsUseReportDetails() {
        await this.$vs.loading({
          container: '#sundry-item-predicted-use-report',
          scale: 0.45
        })
        try {
          const {data} = await sundrySupplierRepository.getSundryItemsUseReportDetails(this.page, this.filterQuery, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#sundry-item-predicted-use-report > .con-vs-loading')
      },

      filterQueryUpdate (){
        this.fetchSundryItemsUseReportDetails()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundryItemsUseReportDetails()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundryItemsUseReportDetails()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    watch : {
      page(){
        this.fetchSundryItemsUseReportDetails()
      },
      perPage() {
        this.fetchSundryItemsUseReportDetails()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
